import { MapPin, ExternalLink } from 'lucide-react';

interface LocationCardProps {
  locationName?: string | null;
  latitude?: number | null;
  longitude?: number | null;
}

function formatCoordinates(lat: number, lng: number): string {
  return `${lat.toFixed(5)}, ${lng.toFixed(5)}`;
}

function getMapsUrl(lat: number, lng: number, name?: string | null): string {
  const q = name ? encodeURIComponent(name) : `${lat},${lng}`;
  return `https://www.google.com/maps/search/?api=1&query=${q}&center=${lat},${lng}`;
}

export function LocationCard({ locationName, latitude, longitude }: LocationCardProps) {
  const hasCoords = latitude != null && longitude != null;

  if (!locationName && !hasCoords) return null;

  const mapsUrl = hasCoords ? getMapsUrl(latitude!, longitude!, locationName) : null;

  const content = (
    <div className="flex items-center gap-3 rounded-lg bg-surface-secondary p-3 group">
      <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-emerald-100 dark:bg-emerald-900/30">
        <MapPin className="h-5 w-5 text-emerald-600" />
      </div>
      <div className="flex-1 min-w-0">
        {locationName && (
          <p className="text-sm font-medium text-text-secondary truncate">{locationName}</p>
        )}
        {hasCoords && (
          <p className="text-xs text-text-tertiary">{formatCoordinates(latitude!, longitude!)}</p>
        )}
      </div>
      {mapsUrl && (
        <ExternalLink className="h-4 w-4 text-text-quaternary group-hover:text-text-secondary transition-colors shrink-0" />
      )}
    </div>
  );

  if (mapsUrl) {
    return (
      <a
        href={mapsUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="block hover:opacity-90 transition-opacity"
      >
        {content}
      </a>
    );
  }

  return content;
}
